import { axios } from '@/plugins/axios-pol'

const basePath = '/profesionalizacion/api/Profesionalizacion'

export default class CapacitacionesApiRepository {
  // AÑOS CURSO
  async getAllAniosCursos() {
    const { data } = await axios.get(`${basePath}/aniosCursos`)
    return data.data
  }

  async getAnioCursoById(idAnioCurso) {
    const { data } = await axios.get(`${basePath}/aniosCursos/${idAnioCurso}`)
    return data.data
  }

  async getPerfilesCursosByAnioCurso(idAnioCurso) {
    const { data } = await axios.get(`${basePath}/aniosCursos/${idAnioCurso}/perfilesCursos`)
    return data.data
  }

  async getPerfilCursoByAnioCursoAndId(idAnioCurso, idPerfilCurso) {
    const { data } = await axios.get(`${basePath}/aniosCursos/${idAnioCurso}/perfilesCursos/${idPerfilCurso}`)
    return data.data
  }

  async crearAnioCurso(payload) {
    const { data } = await axios.post(`${basePath}/aniosCursos`, payload)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async actualizarAnioCurso(idAnioCurso, payload) {
    const { data } = await axios.put(`${basePath}/aniosCursos/${idAnioCurso}`, payload)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async desactivarAnioCurso(idAnioCurso) {
    const { data } = await axios.put(`${basePath}/aniosCursos/${idAnioCurso}/delete`)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  // PERFILES CURSO
  async getAllPerfilesCursos() {
    const { data } = await axios.get(`${basePath}/perfilesCursos`)
    return data.data
  }

  async getPerfilCursoById(idPerfilCurso) {
    const { data } = await axios.get(`${basePath}/perfilesCursos/${idPerfilCurso}`)
    return data.data
  }

  async getCategoriasByPerfilCurso(idPerfilCurso) {
    const { data } = await axios.get(`${basePath}/perfilesCursos/${idPerfilCurso}/categorias`)
    return data.data
  }

  async getCategoriaByPerfilCursoAndId(idPerfilCurso, idCategoria) {
    const { data } = await axios.get(`${basePath}/perfilesCursos/${idPerfilCurso}/categorias/${idCategoria}`)
    return data.data
  }

  async crearPerfilCurso(payload) {
    const { data } = await axios.post(`${basePath}/perfilesCursos`, payload)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async actualizarPerfilCurso(idPerfilCurso, payload) {
    const { data } = await axios.put(`${basePath}/perfilesCursos/${idPerfilCurso}`, payload)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async desactivarPerfilCurso(idPerfilCurso) {
    const { data } = await axios.put(`${basePath}/perfilesCursos/${idPerfilCurso}/delete`)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  // CATEGORÍAS POR TIPO DE CURSO
  async getCategoriasByTipoCurso(idTipoCurso) {
    const { data } = await axios.get(`${basePath}/tipoCursos/${idTipoCurso}/categorias`)
    return data.data
  }

  async getCategoriaByTipoCursoAndId(idTipoCurso, idCategoria) {
    const { data } = await axios.get(`${basePath}/tipoCursos/${idTipoCurso}/categorias/${idCategoria}`)
    return data.data
  }

  // CATEGORÍAS
  async getAllCategorias() {
    const { data } = await axios.get(`${basePath}/categorias`)
    return data.data
  }

  async getCategoriaById(idCategoria) {
    const { data } = await axios.get(`${basePath}/categorias/${idCategoria}`)
    return data.data
  }

  async crearCategoria(payload) {
    const { data } = await axios.post(`${basePath}/categorias`, payload)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async actualizarCategoria(idCategoria, payload) {
    const { data } = await axios.put(`${basePath}/categorias/${idCategoria}`, payload)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async desactivarCategoria(idCategoria) {
    const { data } = await axios.put(`${basePath}/categorias/${idCategoria}/delete`)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async desactivarSubcategoria(idSubcategoria) {
    const { data } = await axios.put(`${basePath}/subcategorias/${idSubcategoria}/delete`)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  // ASIGNACIÓN DE CURSOS A PERSONAL
  async removerAsignacionCurso(idPersonal, idAsignacionCurso) {
    const { data } = await axios.put(`${basePath}/personal/${idPersonal}/asignacionCursos/${idAsignacionCurso}/remueve`)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  // VINCULACIÓN DE PERSONAL A CURSOS NO PROGRAMADOS
  async getAllCursosNoProgramadosPersonal() {
    const { data } = await axios.get(`${basePath}/cursosNoProgramadosPersonal`)
    return data.data
  }

  async getCursosNoProgramadosByPersonal(idPersonal) {
    const { data } = await axios.get(`${basePath}/personal/${idPersonal}/cursosNoProgramados`)
    return data.data
  }

  async vincularPersonalACurso(payload) {
    if (!payload.fk_idCurso || !payload.fk_idPersonal || !payload.fk_idEstatus) {
      throw new Error('fk_idCurso, fk_idPersonal y fk_idEstatus son obligatorios')
    }

    const formData = new FormData()
    formData.append('fk_idCurso', payload.fk_idCurso)
    formData.append('fk_idPersonal', payload.fk_idPersonal)
    formData.append('fk_idEstatus', payload.fk_idEstatus)
    formData.append('asistencia', payload.asistencia ?? true)
    formData.append('calificacion', payload.calificacion ?? '')
    formData.append('calificacionEvaluacion', payload.calificacionEvaluacion ?? '')
    formData.append('comentario', payload.comentario ?? '')

    const { data } = await axios.post(`${basePath}/cursosNoProgramadosPersonal`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  // NOTA (EDF-374): verificado con backend. fk_idCurso, fk_idPersonal y
  // fk_idEstatus son obligatorios en este payload (el API responde 500 con
  // "Los campos fk_idCurso, fk_idPersonal y fk_idEstatus son obligatorios."
  // si falta alguno, si fk_idEstatus va null, o si el body no va como
  // multipart/form-data: el endpoint de creación (vincularPersonalACurso)
  // bindea por [FromForm], así que este PUT usa el mismo formato.
  async actualizarCursoNoProgramadoPersonal(idCursoPersonal, payload) {
    if (!payload.fk_idCurso || !payload.fk_idPersonal || !payload.fk_idEstatus) {
      throw new Error('fk_idCurso, fk_idPersonal y fk_idEstatus son obligatorios')
    }

    const formData = new FormData()
    formData.append('fk_idCurso', payload.fk_idCurso)
    formData.append('fk_idPersonal', payload.fk_idPersonal)
    formData.append('fk_idEstatus', payload.fk_idEstatus)
    formData.append('asistencia', payload.asistencia ?? true)
    formData.append('calificacion', payload.calificacion ?? '')
    formData.append('calificacionEvaluacion', payload.calificacionEvaluacion ?? '')
    formData.append('comentario', payload.comentario ?? '')

    const { data } = await axios.put(`${basePath}/cursosNoProgramadosPersonal/${idCursoPersonal}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }

  async desvincularPersonalDeCurso(idCursoPersonal) {
    const { data } = await axios.put(`${basePath}/cursosNoProgramadosPersonal/${idCursoPersonal}/remueve`)
    if (!data.result) throw new Error(data.error_message)
    return data.data
  }
}
